export const operatorLabels = {
  equals: "equals",
  not_equals: "does not equal",
  contains: "contains",
  not_contains: "does not contain",
  starts_with: "starts with",
  ends_with: "ends with",
  greater_than: "greater than",
  less_than: "less than",
  greater_or_equal: "greater than or equal",
  less_or_equal: "less than or equal",
  is_empty: "is empty",
  is_not_empty: "is not empty",
  before: "before",
  after: "after",
  is_true: "is true",
  is_false: "is false",
};

// Example field configuration
export const exampleFieldConfig = [
  {
    label: "Name",
    value: "name",
    type: "text",
    operators: [
      "equals",
      //   "not_equals",
      //   "contains",
      //   "not_contains",
      //   "starts_with",
      //   "ends_with",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "Email",
    value: "email",
    type: "text",
    operators: [
      "equals",
      //   "not_equals",
      //   "contains",
      //   "not_contains",
      "is_empty",
      "is_not_empty",
    ],
  },
  {
    label: "Age",
    value: "age",
    type: "number",
    operators: [
      "equals",
      "not_equals",
      "greater_than",
      "less_than",
      //   "greater_or_equal",
      //   "less_or_equal",
      "is_empty",
      "is_not_empty",
    ],
  },
  //   {
  //     label: "Registration Date",
  //     value: "registration_date",
  //     type: "date",
  //     operators: [
  //       "equals",
  //       "not_equals",
  //       "before",
  //       "after",
  //       "is_empty",
  //       "is_not_empty",
  //     ],
  //   },
  //   {
  //     label: "Active",
  //     value: "active",
  //     type: "boolean",
  //     operators: ["is_true", "is_false"],
  //   },
  //   {
  //     label: "Score",
  //     value: "score",
  //     type: "number",
  //     operators: [
  //       "equals",
  //       "not_equals",
  //       "greater_than",
  //       "less_than",
  //       "greater_or_equal",
  //       "less_or_equal",
  //     ],
  //   },
];
